import { Link } from "react-router-dom";
import Seo from "@/components/base/Seo";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SectionHeading from "@/components/base/SectionHeading";

const SITE_URL = "https://wqxtv.cn";

const pillars = [
  {
    icon: "ri-focus-3-line",
    title: "网站定位",
    text: "专注爆料直播的内容档案馆。我们不生产直播，只把公开直播里真正有信息量的片段整理出来，让错过现场的人也能一字不漏地补上。",
  },
  {
    icon: "ri-compass-3-line",
    title: "发展理念",
    text: "片段的价值不在于长，而在于准。我们坚持给每一条片段标注时间点、上下文与来源场次，让回看这件事变得简单。",
  },
  {
    icon: "ri-shield-check-line",
    title: "内容原则",
    text: "只整理公开可查的录播内容，不放大未经证实的说法；对存在争议的口径，同时保留多方表述，交给读者自行判断。",
  },
];

const testimonials = [
  {
    name: "夜猫子观众",
    role: "常年错过直播的上班族",
    text: "下班回家打开片段库，十分钟就能把当天最热的几段补完，关键发言还有时间点，不用在几小时录播里乱找。",
  },
  {
    name: "自习室常客",
    role: "备考读者",
    text: "最爱的是直播内容文字版。有时候片段看着不过瘾，就想逐句看原话，这里的转写确实完整。",
  },
  {
    name: "内容编辑小林",
    role: "媒体从业者",
    text: "弹幕摘录这点很特别，能看出当时观众真实的反应，写稿引用现场气氛时帮了大忙。",
  },
];

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于爆料现场",
    url: `${SITE_URL}/about`,
    inLanguage: "zh-CN",
    description: "爆料现场的网站定位、发展理念、内容原则、用户口碑与联系方式。",
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "爆料现场",
    url: SITE_URL,
    email: "clip@baoliaoxianchang.com",
    description: "公开直播高能片段的整理与索引平台。",
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: SITE_URL },
      { "@type": "ListItem", position: 2, name: "关于我们", item: `${SITE_URL}/about` },
    ],
  },
];

export default function About() {
  return (
    <>
      <Seo
        title="关于我们 | 爆料现场 · 爆料直播片段整理与索引"
        description="爆料现场专注整理爆料直播片段，说明网站定位、发展理念与内容原则，并提供片段线索提交与联系邮箱。"
        keywords="关于爆料现场,爆料直播,爆料片段整理,内容原则,联系方式"
        canonical={`${SITE_URL}/about`}
        jsonLd={jsonLd}
      />

      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />

      <section className="mx-auto w-full max-w-content px-4 pt-10 md:px-6 md:pt-14">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.2em] text-primary-600 uppercase">
              <span className="inline-block h-px w-6 bg-primary-500" />
              About Us
            </span>
            <h1 className="mt-3 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
              关于爆料现场
            </h1>
            <p className="mt-5 font-body text-sm leading-relaxed text-foreground-600 md:text-base">
              爆料现场诞生于一个很具体的烦恼：直播越来越长，但真正值得回看的可能只有几分钟。
              于是我们做了一件笨功夫——把爆料直播里的高能瞬间一段段剪出来，配上主播关键发言、
              弹幕热议和直播内容文字版，让「错过直播」不再等于「错过现场」。
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link
                to="/clips"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-label text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-play-list-2-line" />
                浏览片段库
              </Link>
              <a
                href="mailto:clip@baoliaoxianchang.com"
                rel="nofollow"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-label text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
              >
                <i className="ri-mail-send-line" />
                提交爆料线索
              </a>
            </div>
          </div>

          <div className="h-[260px] w-full overflow-hidden rounded-lg border border-background-200 md:h-[360px]">
            <img
              src="https://readdy.ai/api/search-image?query=stylized%20flat%20editorial%20illustration%20of%20a%20magazine%20archive%20shelf%20with%20folders%20and%20a%20spotlight%20in%20a%20calm%20studio%2C%20warm%20cream%20background%2C%20vermillion%20orange%20and%20amber%20palette%2C%20soft%20dramatic%20lighting%2C%20grainy%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20no%20text&width=900&height=600&seq=bolo-about-01&orientation=landscape"
              alt="爆料现场片段档案馆工作场景插画"
              title="爆料现场 片段档案馆"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>
      </section>

      <section className="mx-auto w-full max-w-content px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="我们坚持什么"
          title="定位、理念与内容原则"
          description="这三件事决定了我们收录什么、怎么收录，以及遇到争议时怎么处理。"
        />
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          {pillars.map((item, index) => (
            <article
              key={item.title}
              className={`flex flex-col gap-4 rounded-lg border border-background-200 p-6 ${
                index === 1 ? "bg-accent-100/70 dark:bg-accent-950/40" : "bg-background-100"
              }`}
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
              <p className="font-body text-sm leading-relaxed text-foreground-600">{item.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="bg-background-100">
        <div className="mx-auto w-full max-w-content px-4 py-12 md:px-6 md:py-16">
          <SectionHeading
            eyebrow="用户口碑"
            title="他们在爆料现场做什么"
            description="来自长期读者的真实使用场景，也是我们继续整理下去的理由。"
          />
          <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
            {testimonials.map((item) => (
              <figure key={item.name} className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-6">
                <i className="ri-double-quotes-l text-2xl text-primary-400" />
                <blockquote className="font-body text-sm leading-relaxed text-foreground-700">
                  {item.text}
                </blockquote>
                <figcaption className="mt-auto flex items-center gap-3 pt-2">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 font-label text-sm text-background-50">
                    {item.name.slice(0, 1)}
                  </span>
                  <span className="flex flex-col">
                    <span className="font-label text-sm text-foreground-900">{item.name}</span>
                    <span className="font-label text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto w-full max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 rounded-lg border border-background-200 bg-secondary-50 p-6 md:p-10 lg:grid-cols-2 dark:bg-secondary-950/50">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">联系我们</h2>
            <p className="mt-4 font-body text-sm leading-relaxed text-foreground-600">
              无论是提交爆料线索、纠正片段信息，还是希望我们整理某个场次，都欢迎写信给我们。
              编辑会逐条查看，收录后会在片段页标注来源场次。
            </p>
          </div>
          <div className="flex flex-col gap-4">
            <a
              href="mailto:clip@baoliaoxianchang.com"
              rel="nofollow"
              className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-5 py-4 transition-colors hover:border-primary-400"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-mail-line text-lg" />
              </span>
              <span className="flex flex-col">
                <span className="font-label text-xs text-foreground-500">片段线索与纠错</span>
                <span className="font-label text-sm text-foreground-950">clip@baoliaoxianchang.com</span>
              </span>
            </a>
            <div className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-5 py-4">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                <i className="ri-time-line text-lg" />
              </span>
              <span className="flex flex-col">
                <span className="font-label text-xs text-foreground-500">片段更新节奏</span>
                <span className="font-label text-sm text-foreground-950">热门场次当晚归档，普通场次 24 小时内</span>
              </span>
            </div>
            <div className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-5 py-4">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-quill-pen-line text-lg" />
              </span>
              <span className="flex flex-col">
                <span className="font-label text-xs text-foreground-500">内容合作</span>
                <span className="font-label text-sm text-foreground-950">场次整理、话题共建均可来信沟通</span>
              </span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}